// import { findDOMNode } from 'react-dom';

export const filtersSource = {
  beginDrag(props) {
    props.setDragging(true);
    return {
      key: props.filter.key,
      parentKey: props.parentKey || null,
    };
  },

  endDrag(props) {
    if (props.handleDrop) {
      props.handleDrop();
    }
    props.setDragging(false);
  },

  canDrag(props) {
    return props.canDrag;
  },
};

export const filtersTarget = {
  hover(props, monitor) {
    const dragItem = monitor.getItem();
    const hoverItem = props.filter;

    const dragIsChild = /^tax_group_\d+_tax_\d+$/.test(dragItem.key);

    if (dragIsChild) {
      const dragParentKey = dragItem.parentKey;
      const hoverIsChild = /^tax_group_\d+_tax_\d+$/.test(hoverItem.key);
      const hoverParentKey = props.parentKey || hoverItem.key;

      if (
        (hoverIsChild && hoverParentKey !== dragParentKey) ||
        (!hoverIsChild && hoverItem.key !== dragParentKey)
      ) {
        return;
      }
    }

    if (dragItem.key === hoverItem.key) return;

    props.moveFilter(dragItem.key, hoverItem.key);
  },
};
